import React, { useContext, useEffect, useState } from "react";
import "./dashboard.scss";
import Button from "../button/button";
import Modal from "react-bootstrap/Modal";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { DataContext } from "../../App";
import axios from "axios";

function DashboardMain() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const handleCreateAgentModal = () => {
    setUpdateagent(false);
    setShow(!show);
  };
  const { data, setData } = useContext(DataContext);
  const { updateagent, setUpdateagent } = useContext(DataContext);
  const [spinner, setSpinner] = useState(false);
  const [Campaignspinner, setCampaignSpinner] = useState(false);
  const [alldata, setAlldata] = useState({});
  const [totalCampaigns, setTotalCampaigns] = useState("");
  const Apiurl = process.env.REACT_APP_API_KEY;
  const logintoken = localStorage.getItem("authToken");
  const responseapi = () => {
    setSpinner(true);
    axios
      .get(`${Apiurl}/getAllAgent`, {
        headers: {
          Authorization: `Bearer ${logintoken}`,
        },
      })
      .then((res) => {
        setAlldata(res.data.response || []);
        setSpinner(false);
      })
      .catch((err) => {
        console.log(err);
        setSpinner(false);
      });
  };

  // Campaigns get API
  const getCampaigns = () => {
    setCampaignSpinner(true);
    axios
      .get(`${Apiurl}/getCampaigns`, {
        headers: {
          "Content-Type": "application/json",
          "User-Agent": "insomnia/10.0.0",
          Authorization: `Bearer ${logintoken}`,
        },
      })
      .then((response) => {
        console.log(response.data.data);
        setTotalCampaigns(response.data.data);
        setCampaignSpinner(false);
      })
      .catch((err) => {
        console.error(err);
        setCampaignSpinner(false);
      });
  };

  useEffect(() => {
    responseapi();
    getCampaigns();
    setData({
      _id: "",
      customerID: "",
      AgentName: "",
      AgentTitle: "",
      CompanyName: "",
      FallBackNote:
        "If you're unsure about the type of loan you need, I can help clarify options based on your business needs and financial goals. Let's explore the best solution together.",
      audioId: "",
      greetings:
        "Hello! Thank you for calling [Company Name]. This is [Agent Name], your AI assistant. How can I assist you today with your business loan inquiry?",
      Temperature: 0.2,
      Maximum_Tokens: "654",
      Top_P: "1",
      Frequency_Penality: "0",
      Presence_Penality: "0",
      Model: "",
      Script: "",
      Scriptshow: `**Introduction:**
      "Hello [Client First Name], this is {{agent_name}} from {{company_name}}. I am calling to inform you about our new SBA FastTrack program, designed for businesses looking to expand. It offers up to $350,000 in working capital with a 10-year term and monthly payments. Does your business need any working capital at this time?"
      Your Role:
      If the user's query is from the knowledge base, don't answer off the cuff; refer directly to the knowledge base.
      Personal Information:
      - Your name is {agent_name}.
      - Your company name is {company_name}.
      **Qualifying Questions:**
      1. How long has your business been operating?
      2. Could you share what your business revenue looked like last year?
      3. Do you know your approximate FICO score?
      (Minimum of 2 years required)
      (Minimum of $200,000 required)
      (Minimum of 640 required)
      "Base of above question told him if he qualified for loan"
      **Scheduling the Consultation:**
      "Based on your responses, it sounds like you are a great fit for this program. Let's schedule a consultation to discuss this further. How does [Day], [Date] at [Time] work for you? If that doesn’t work, I have other times available."
      **Confirmation of Appointment:**
      "Perfect, you're all set for [Day], [Date] at [Time]. You will be speaking with [Loan Officer], who is an expert in SBA loans. You will soon receive an email with a link to a secure loan application. Completing this before our meeting will ensure we make the most out of our time together."
      **Objection Handling Tips:**
      - Listen attentively and allow the prospect to fully express their concerns.
      - Acknowledge and validate the prospect's feelings to build trust.
      - Determine the root of any objections to better address them and move towards closing the conversation positively.
      **Advanced Objection Handling Techniques:**
      - "If a prospect is concerned about the time commitment, reassure them that our streamlined process minimizes downtime and maximizes efficiency."
      - "Should the topic of financial readiness arise, discuss our flexible terms that are designed to accommodate various financial states, emphasizing the supportive nature of our program.", confinement:"Use the exact language provided in the script for introduction, qualifying questions, scheduling, and confirmation steps to maintain consistency and compliance. If the client’s query is referenced in the knowledge base, answer directly from it without improvisation to ensure all information is accurate and approved. Personalize the script by filling in placeholders like the client's first name, agent name ({agent_name}), company name ({company_name}), and specific dates, days, and times for appointments. Ensure clients meet all qualifying criteria (minimum 2 years in operation, $200,000 annual revenue, 640 FICO score) before proceeding to schedule a consultation. Politely inform clients if they do not meet these requirements. Maintain a neutral tone; focus on suggesting and highlighting the program’s benefits rather than pressuring the client. Listen to and acknowledge the client’s concerns, ensuring they feel heard and validated. Use the standard objection handling tips and advanced techniques provided to address objections constructively and keep the conversation positive. Reconfirm appointment details with the client and remind them to complete the pre-meeting application to ensure a productive consultation with the loan officer.`,
      confinement: `Use the exact language provided in the script for introduction, qualifying questions, scheduling, and confirmation steps to maintain consistency and compliance.

If the client’s query is referenced in the knowledge base, answer directly from it without improvisation to ensure all information is accurate and approved.

Personalize the script by filling in placeholders like the client's first name, agent name ({agent_name}), company name ({company_name}), and specific dates, days, and times for appointments.

Ensure clients meet all qualifying criteria (minimum 2 years in operation, $200,000 annual revenue, 640 FICO score) before proceeding to schedule a consultation. Politely inform clients if they do not meet these requirements.

Maintain a neutral tone; focus on suggesting and highlighting the program’s benefits rather than pressuring the client.

Listen to and acknowledge the client’s concerns, ensuring they feel heard and validated. Use the standard objection handling tips and advanced techniques provided to address objections constructively and keep the conversation positive.

Reconfirm appointment details with the client and remind them to complete the pre-meeting application to ensure a productive consultation with the loan officer.






`,
      Script: "",
      knowledgeBaseId: "",
      phoneNumber: "",
      livetransfer: "",
      hubspot_meetinglink: "",
    });
  }, []);
  return (
    <div className="dash-main">
      <section className="dashboard-sec">
        <div className="creation-box">
          <div className="ist">
            <h4 className="greycolor Carmen-regular-font text-center">
              Active Agents
            </h4>
            {spinner ? (
              <span className="spinner"></span>
            ) : (
              <div className="active-circle">
                <h1 className="primarycolor Carmen-medium-font text-center">
                  {alldata ? alldata.length : "0"}
                </h1>
              </div>
            )}
          </div>
          <div className="second">
            <h2 className="darkcolor Carmen-medium-font text-center">Agents</h2>
            <h5 className="greycolor Carmen-medium-font text-center">
              Create your own customized agent
            </h5>
            <Button
              text="Create Agent"
              className="primary-button w-100 fs-20 mx-auto"
              maxWidth="280px"
              padding="13px 26px"
              onClick={handleCreateAgentModal}
            />
          </div>
          <div className="ist">
            <h4 className="greycolor Carmen-regular-font text-center">
              Total Campaigns
            </h4>
            {Campaignspinner ? (
              <span className="spinner"></span>
            ) : (
              <div className="active-circle">
                <h1 className="primarycolor Carmen-medium-font text-center">
                  {totalCampaigns ? totalCampaigns.length : "0"}
                </h1>
              </div>
            )}
          </div>
        </div>
        {/* <div className="create-box">
          <h2 className="Carmen-semibold-font darkcolor text-center">Agents</h2>
          <h5 className="greycolor Carmen-medium-font text-center">
            Create your own customized agent
          </h5>
          <Button
            text="Continue"
            className="primary-button w-100 fs-20 mx-auto"
            maxWidth="280px"
            padding="13px 26px"
            onClick={handleCreateAgentModal}
          />
        </div> */}
        {/* <div className="templates-div">
          <h2 className="Carmen-semibold-font primarycolor">Templates</h2>
          <div className="template-cards">
            <div className="template">
              <div className="top">
                <h4 className="Carmen-bold-font darkcolor">Angliana</h4>
                <div className="bound">
                  <p className="Carmen-bold-font secondarycolor">In-bound</p>
                  <div className="bound-layer"></div>
                </div>
              </div>
              <h5 className="Carmen-regular-font greycolor">
                Lorem ipsum dolor sit amet consectetur. Tincidunt tristique
                pretium est congue massa praesent eget. Morbi sit laoreet
                scelerisque feugiat tristique sed facilisi eu aliquet.
              </h5>
              <Button
                text="Use me"
                className="primary-button w-100 fs-16 mx-auto"
                maxWidth="242px"
                padding="19px 26px"
                img="/assets/icons/useme.svg"
              />
            </div>
            <div className="template">
              <div className="top">
                <h4 className="Carmen-bold-font darkcolor"> Angliana</h4>
                <div className="bound">
                  <p className="Carmen-bold-font secondarycolor">Out-bound</p>
                  <div className="bound-layer"></div>
                </div>
              </div>
              <h5 className="Carmen-regular-font greycolor">
                Lorem ipsum dolor sit amet consectetur. Tincidunt tristique
                pretium est congue massa praesent eget. Morbi sit laoreet
                scelerisque feugiat tristique sed facilisi eu aliquet.
              </h5>
              <Button
                text="Use me"
                className="primary-button w-100 fs-16 mx-auto"
                maxWidth="242px"
                padding="19px 26px"
                img="/assets/icons/useme.svg"
              />
            </div>
          </div>
        </div> */}
        <Modal
          show={show}
          onHide={handleCreateAgentModal}
          centered
          className="create-modal"
        >
          <Modal.Body>
            <img
              src="/assets/icons/modalclose.svg"
              alt="..."
              className="pointer close-btn"
              onClick={handleCreateAgentModal}
            />
            <h2 className="Carmen-semibold-font primarycolor">
              What you want to create?
            </h2>
            <Button
              text="In-bound Agent"
              className="primary-button w-100 fs-20 mx-auto"
              maxWidth="210px"
              padding="13px 5px"
              onClick={() =>
                navigate("/create-agent", { state: { data: "Inbound_Call" } })
              }
            />
            <p className="Carmen-regular-font greycolor text-center">OR</p>
            <Button
              text="Out-bound Agent"
              className="primary-button w-100 fs-20 mx-auto"
              maxWidth="210px"
              padding="13px 5px"
              onClick={() =>
                navigate("/create-agent", { state: { data: "Outbound_Call" } })
              }
            />
          </Modal.Body>
        </Modal>
      </section>
      <Outlet />
    </div>
  );
}

export default DashboardMain;
